import type { FactionBE, GameMode } from "@/game-eft/constants/constants.mjs";

export default function getPlayerSeasonStatKeyState(
  profileId: string,
  gameMode: GameMode.ARENA | GameMode.DEFAULT,
  faction: FactionBE,
): string {
  return btoa(profileId + gameMode + faction);
}
